import { Box } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";

import { t } from "i18next";
import dayjs from "dayjs";
import BreadcrumbsTitle from "../../../components/ui/breadcrumbsTitle";
import SelectCheckMarkBranch from "../../../components/ui/select/selectCheckMarkBranch";
import { TextTable } from "../../../components/ui/textfield/textfieldCustom";
import { MyContext } from "../../../context/MyContext";
import DataTableReport from "../../../components/ui/dataTable/dataTableReport";
import i18n from "../../../locals/i18n";

function ReportByPreDefines() {
  const [rows, setRows] = useState([]);
  const [columns, setColumns] = useState([]);
  const [exportColumnName, setExportColumnName] = useState(null);
  const {
    setBranchSelectReport,
    branchSelectReportDate,
    reportAll,
    fetchReport,
  } = useContext(MyContext);
  const [isLoadingData, setIsLoadingData] = useState(
    reportAll.length > 0 ? false : true
  );

  const fetchData = async () => {
    let headers = [];
    let dataPreDefines = [];

    if (reportAll) {
      // Filter only successful receipts
      const successfulReceipts = reportAll.filter(
        (receipt) => receipt.receipt_status === "success"
      );

      // Collect all pre-defines from all receipts
      successfulReceipts.forEach((receipt) => {
        receipt.receipt_sale_products.forEach((saleProduct) => {
          if (saleProduct.pre_defines && saleProduct.pre_defines.length > 0) {
            saleProduct.pre_defines.forEach((preDefine) => {
              const preDefineName = preDefine.rspp.name || "Unknown";
              const amount = preDefine.rspp?.amount || 0;
              const price = preDefine.rspp?.price || 0;
              const branchName =
                receipt.receipt_config_receipt?.config_receipt_lang
                  ?.branch_name || null;

              // Check if this pre-define already exists in the collection
              const existingItem = dataPreDefines.find(
                (item) => item.id === preDefine.id
              );

              if (existingItem) {
                // Aggregate existing item
                existingItem.amount += amount;
                existingItem.totalPrice += price * amount;
              } else {
                // Add new item
                dataPreDefines.push({
                  id: preDefine.id,
                  name: preDefineName,
                  price: price,
                  amount: amount,
                  totalPrice: price * amount,
                  branchName: branchName,
                  saleProductName: saleProduct.name,
                });
              }
            });
          }
        });
      });

      // Sort by name
      dataPreDefines.sort((a, b) => {
        if (a.name < b.name) return -1;
        if (a.name > b.name) return 1;
        return 0;
      });

      setRows(dataPreDefines);
    }

    // Define columns
    let dataColumns = [
      {
        header: t("global_name"),
        accessorKey: "name",
        minWidth: 150,
        Cell: ({ cell }) => <TextTable props={{ text: cell.getValue() }} />,
      },
      // {
      //   header: t("report_sale_product"),
      //   accessorKey: "saleProductName",
      //   minWidth: 150,
      //   Cell: ({ cell }) => <TextTable props={{ text: cell.getValue() }} />,
      // },
      {
        header: t("report_amount"),
        accessorKey: "amount",
        isSorting: true,
        minWidth: i18n.language === "th" ? 70 : 70,
        Cell: ({ cell }) => (
          <TextTable
            props={{
              text: Number(cell.getValue()).toLocaleString(undefined, {
                minimumFractionDigits: 0,
                maximumFractionDigits: 0,
              }),
              alignText: "right",
            }}
          />
        ),
      },
      // {
      //   header: t("report_price_per_unit"),
      //   accessorKey: "price",
      //   isSorting: true,
      //   minWidth: i18n.language === "th" ? 110 : 100,
      //   Cell: ({ cell }) => (
      //     <TextTable
      //       props={{
      //         text: Number(cell.getValue()).toLocaleString(undefined, {
      //           minimumFractionDigits: 2,
      //           maximumFractionDigits: 2,
      //         }),
      //         alignText: "right",
      //       }}
      //     />
      //   ),
      // },
      {
        header: t("report_total"),
        accessorKey: "totalPrice",
        isSorting: true,
        minWidth: 110,
        Cell: ({ cell }) => (
          <TextTable
            props={{
              text: Number(cell.getValue()).toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              }),
              alignText: "right",
            }}
          />
        ),
      },
      {
        header: t("report_branch"),
        accessorKey: "branchName",
        minWidth: 100,
        Cell: ({ cell }) => <TextTable props={{ text: cell.getValue() }} />,
      },
    ];

    dataColumns.forEach((item) => {
      if (item.header !== "Image" && item.header !== "Action") {
        headers.push(item.header);
      }
    });

    setColumns(dataColumns);

    // Create CSV export data
    const csvStringArray = [
      headers,
      ...dataPreDefines.map((item) => [
        item.name,
        item.saleProductName,
        item.amount,
        item.price,
        item.totalPrice,
        item.branchName,
      ]),
    ]
      .map((row) => row.join(","))
      .join("\n");

    setExportColumnName(csvStringArray);
    setIsLoadingData(false);
  };

  const onConfirm = async () => {
    await setIsLoadingData(true);
    await fetchReport();
  };

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reportAll]);

  return (
    <Box>
      <BreadcrumbsTitle
        props={{
          title: t("report_by_pre_defines"),
        }}
      />
      <Box>
        <SelectCheckMarkBranch
          props={{
            onConfirm,
            setBranchSelectReport,
          }}
        />

        <DataTableReport
          statusViewMode={true}
          rows={rows}
          isLoadingData={isLoadingData}
          exportColumnName={exportColumnName}
          columns={columns}
          height={0.85}
          fileName={
            t("report_by_pre_defines") +
            `${dayjs(branchSelectReportDate.startDate).format(
              "DD/MM/YYYY"
            )} - ${dayjs(branchSelectReportDate.endDate).format("DD/MM/YYYY")}`
          }
        />
      </Box>
    </Box>
  );
}

export default ReportByPreDefines;
